import React from "react";

function UsersSidebar({ fill }) {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="UserOutline">
          <path
            id="Vector"
            d="M13.3333 5.83333C13.3333 6.71739 12.9821 7.56523 12.357 8.19036C11.7319 8.81548 10.884 9.16667 9.99996 9.16667C9.1159 9.16667 8.26806 8.81548 7.64294 8.19036C7.01782 7.56523 6.66663 6.71739 6.66663 5.83333C6.66663 4.94928 7.01782 4.10143 7.64294 3.47631C8.26806 2.85119 9.1159 2.5 9.99996 2.5C10.884 2.5 11.7319 2.85119 12.357 3.47631C12.9821 4.10143 13.3333 4.94928 13.3333 5.83333ZM9.99996 11.6667C8.45286 11.6667 6.96913 12.2812 5.87517 13.3752C4.78121 14.4692 4.16663 15.9529 4.16663 17.5H15.8333C15.8333 15.9529 15.2187 14.4692 14.1247 13.3752C13.0308 12.2812 11.5471 11.6667 9.99996 11.6667Z"
            stroke={fill}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </svg>
    </>
  );
}

export default UsersSidebar;
